import { render } from "./Stik.vue?vue&type=template&id=6d4dd28d&scoped=true"
import script from "./Stik.vue?vue&type=script&lang=js"
export * from "./Stik.vue?vue&type=script&lang=js"

import "./Stik.vue?vue&type=style&index=0&id=6d4dd28d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4dd28d"]])

export default __exports__